import { useRef } from "react";
import { Center, Box, Button, Text, HStack } from "@chakra-ui/react";
import RenderPDF from "./render-pdf";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";

const PDFCard = ({ pdf_location, file_name }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <Box boxShadow="lg" rounded="lg" zIndex={1}>
        <RenderPDF pdf_location={pdf_location} ref={componentRef} />
      </Box>
      <Center>
        <HStack mt={5} spacing={10}>
          <Button
            as="button"
            colorScheme="teal"
            type="submit"
            minW="100px"
            onClick={() => {
              saveAs(pdf_location, file_name);
            }}
          >
            <Text
              color="rgb(245, 250, 255)"
              fontSize={["xs", "xs", "xs", "xs"]}
            >
              Download
            </Text>
          </Button>
          <Button
            as="button"
            colorScheme="teal"
            type="submit"
            minW="100px"
            onClick={handlePrint}
          >
            <Text
              color="rgb(245, 250, 255)"
              fontSize={["xs", "xs", "xs", "xs"]}
            >
              Print
            </Text>
          </Button>
        </HStack>
      </Center>
    </>
  );
};

export default PDFCard;
